/**
 * @file index.tsx
 *
 * @fileoverview Renders blog tags.
 */
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import BlogTagBadge from '~/jobiqo/components/Blog/components/TagBadge';
import { Term } from '~/jobiqo/types/types';
import { Button } from '~/vcl/atoms/01-forms/01-button';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
interface BlogTagsProps {
  /**
   * The blog tags.
   */
  tags: Term[];
}

// The maxiumum amount of tags to show by default.
const MAX_TAGS_AMOUNT = 5;

export default function BlogTags({ tags }: BlogTagsProps) {
  if (tags.length === 0) {
    return null;
  }

  const [expanded, setExpanded] = useState(false);

  const hasMoreTags = tags.length > MAX_TAGS_AMOUNT;
  const shownTags = hasMoreTags ? tags.slice(0, MAX_TAGS_AMOUNT) : tags;

  return (
    <>
      <FlexItems gap={5}>
        {shownTags.map((tag) => (
          <BlogTagBadge key={tag.tid} tag={tag} />
        ))}
        {expanded &&
          tags
            .slice(MAX_TAGS_AMOUNT)
            .map((tag) => <BlogTagBadge key={tag.tid} tag={tag} />)}
      </FlexItems>
      {hasMoreTags && (
        <Button
          color="primary"
          onClick={() => {
            setExpanded(!expanded);
          }}
        >
          {expanded ? (
            <FormattedMessage
              id="show_less_tags"
              defaultMessage="Show less tags"
            />
          ) : (
            <FormattedMessage
              id="show_more_tags"
              defaultMessage="Show more tags"
            />
          )}
        </Button>
      )}
    </>
  );
}
export { BlogTags };
